/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NarrativeType } from './NarrativeType';
import {
    NarrativeTypeFromJSON,
    NarrativeTypeFromJSONTyped,
    NarrativeTypeToJSON,
    NarrativeTypeToJSONTyped,
} from './NarrativeType';
import type { NarrativeClassifierType } from './NarrativeClassifierType';
import {
    NarrativeClassifierTypeFromJSON,
    NarrativeClassifierTypeFromJSONTyped,
    NarrativeClassifierTypeToJSON,
    NarrativeClassifierTypeToJSONTyped,
} from './NarrativeClassifierType';

/**
 * Response model for narrative data
 * @export
 * @interface NarrativeResponse
 */
export interface NarrativeResponse {
    /**
     * 
     * @type {string}
     * @memberof NarrativeResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NarrativeResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NarrativeResponse
     */
    userPrompt: string;
    /**
     * 
     * @type {string}
     * @memberof NarrativeResponse
     */
    systemPrompt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NarrativeResponse
     */
    modelName: string;
    /**
     * 
     * @type {NarrativeClassifierType}
     * @memberof NarrativeResponse
     */
    classifierType: NarrativeClassifierType;
    /**
     * 
     * @type {NarrativeType}
     * @memberof NarrativeResponse
     */
    narrativeType?: NarrativeType | null;
    /**
     * 
     * @type {string}
     * @memberof NarrativeResponse
     */
    version?: string;
    /**
     * 
     * @type {number}
     * @memberof NarrativeResponse
     */
    narrativeId: number;
}



/**
 * Check if a given object implements the NarrativeResponse interface.
 */
export function instanceOfNarrativeResponse(value: object): value is NarrativeResponse {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('userPrompt' in value) || value['userPrompt'] === undefined) return false;
    if (!('modelName' in value) || value['modelName'] === undefined) return false;
    if (!('classifierType' in value) || value['classifierType'] === undefined) return false;
    if (!('narrativeId' in value) || value['narrativeId'] === undefined) return false;
    return true;
}

export function NarrativeResponseFromJSON(json: any): NarrativeResponse {
    return NarrativeResponseFromJSONTyped(json, false);
}

export function NarrativeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NarrativeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'userPrompt': json['user_prompt'],
        'systemPrompt': json['system_prompt'] == null ? undefined : json['system_prompt'],
        'modelName': json['model_name'],
        'classifierType': NarrativeClassifierTypeFromJSON(json['classifier_type']),
        'narrativeType': json['narrative_type'] == null ? undefined : NarrativeTypeFromJSON(json['narrative_type']),
        'version': json['version'] == null ? undefined : json['version'],
        'narrativeId': json['narrative_id'],
    };
}

export function NarrativeResponseToJSON(json: any): NarrativeResponse {
    return NarrativeResponseToJSONTyped(json, false);
}

export function NarrativeResponseToJSONTyped(value?: NarrativeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'user_prompt': value['userPrompt'],
        'system_prompt': value['systemPrompt'],
        'model_name': value['modelName'],
        'classifier_type': NarrativeClassifierTypeToJSON(value['classifierType']),
        'narrative_type': NarrativeTypeToJSON(value['narrativeType']),
        'version': value['version'],
        'narrative_id': value['narrativeId'],
    };
}

